const ONBOARDING_COMPLETED_KEY = 'hiponhero_onboarding_completed';
const TOUR_COMPLETED_KEY = 'hiponhero_tour_completed';

export function markOnboardingCompleted(): void {
  localStorage.setItem(ONBOARDING_COMPLETED_KEY, 'true');
}

export function hasCompletedOnboarding(): boolean {
  return localStorage.getItem(ONBOARDING_COMPLETED_KEY) === 'true';
}

export function resetOnboarding(): void {
  localStorage.removeItem(ONBOARDING_COMPLETED_KEY);
  localStorage.removeItem(TOUR_COMPLETED_KEY);
}
